<template>
  <Modal
    class="tw-translate-y-[-50%] assessment-modal tw-max-w-[1040px]"
    :visible="showRef"
    border-radius="4px"
    @close="handleCloseModal(true)"
  >
    <ModalHeader
      :class="`modal-header`"
      :title="
        getComponentUiText(
          'app-component-assessment-create-assessment-modal-title-create-new-assessment-1',
        )
      "
      @close="handleCloseModal"
    />
    <div
      class="tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-[40px] tw-self-stretch tw-p-[40px] tw-bg-[#FFFFFF]"
    >
      <div
        class="tw-flex tw-items-start tw-flex-col tw-gap-[15px] headingWrapper"
      >
        <span
          class="tw-text-[#211F58] tw-text-[22px] tw-not-italic tw-font-semibold tw-leading-[100%]"
          >{{
            getComponentUiText(
              "app-component-assessment-create-assessment-modal-get-started-1",
            )
          }}</span
        >
        <span
          class="tw-text-[#231F20] tw-text-[15px] tw-not-italic tw-font-normal tw-leading-[145%]"
          >{{
            getComponentUiText(
              "app-component-assessment-create-assessment-modal-description-1",
            )
          }}</span
        >
      </div>
      <div class="tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-[25px]">
        <div
          class="tw-flex tw-flex-col tw-justify-between md:tw-items-start tw-gap-[20px] tw-self-stretch tw-rounded-[4px] tw-p-[10px] md:tw-p-[25px] main"
        >
          <div
            class="tw-w-full tw-flex md:tw-items-center tw-items-start tw-justify-between tw-gap-4 tw-flex-col md:tw-flex-row"
          >
            <div
              class="tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-leading-[15px] tw-min-w-[260px]"
            >
              <span class="tw-font-medium">
                {{
                  getComponentUiText(
                    "app-component-assessment-create-assessment-modal-field-name-1",
                  )
                }}
              </span>
            </div>
            <div
              class="tw-flex tw-flex-col tw-w-full tw-max-w-[100%] md:tw-max-w-[630px] tw-relative"
            >
              <BFormInput
                v-model="name"
                data-cy="create-assessment-assessment-name"
                type="text"
                :placeholder="descriptionNameValue()"
                :class="`tw-border tw-text-[#231F20] tw-h-[66px] tw-leading-none tw-px-[20px] tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#FFFFFF]`"
                class="autoFocus input-default"
              />
            </div>
          </div>
          <div
            class="tw-w-full tw-flex tw-items-start tw-justify-between tw-gap-4 tw-flex-col md:tw-flex-row"
          >
            <div
              class="tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[15px] tw-min-w-[260px] tw-pt-[21px]"
            >
              {{
                getComponentUiText(
                  "app-component-assessment-create-assessment-modal-field-description-1",
                )
              }}
            </div>
            <div
              class="tw-flex tw-flex-col tw-w-full tw-max-w-[100%] md:tw-max-w-[630px] tw-relative"
            >
              <textarea
                ref="autoTextarea"
                v-model="description"
                :placeholder="descriptionValue()"
                :style="`outline-color : #EFF0F1`"
                class="auto-expand input-default tw-min-h-[82px] tw-leading-none tw-px-5 tw-pt-[17.5px] tw-pb-[17px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1]"
                @input="autoResize"
              ></textarea>
            </div>
          </div>
        </div>
        <div
          v-if="assessmentsHistory.length > 0"
          class="tw-flex tw-flex-col tw-gap-[5px] md:tw-gap-[10px] md:tw-flex-row tw-justify-between tw-items-start tw-self-stretch tw-rounded tw-px-[5px] md:tw-px-[20px] tw-py-[25px] main"
        >
          <div class="left">
            <div
              class="tw-flex tw-w-[260px] tw-flex-col tw-items-start tw-gap-2.5 tw-px-0 tw-py-[23px] info"
            >
              <span
                class="tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[100%]"
                >{{
                  getComponentUiText(
                    "app-component-assessment-create-assessment-modal-select-existing-assessment-title-1",
                  )
                }}</span
              >
              <span
                class="tw-text-[#878787] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[145%]"
                >{{
                  getComponentUiText(
                    "app-component-assessment-create-assessment-modal-select-existing-assessment-info-1",
                  )
                }}</span
              >
            </div>
          </div>
          <div
            class="tw-flex tw-max-w-[630px] tw-w-full tw-flex-col tw-items-start tw-gap-5 tw-max-h-[428px] tw-overflow-auto right"
          >
            <ExistingAssessmentDropdown
              v-for="(assessment, index) in assessmentsHistory as any"
              :key="index"
              :selected-assessment-parent="selectedAssessmentParent"
              :assessment-selected-id="assessmentSelected"
              :name="assessment.name"
              :checklist-infor-detail="assessment.checklistInforDetail"
              :date="assessment.date"
              :is-large="assessment.isLarge"
              :history="assessment.history"
              :index="index"
              :is-checked="isChecked"
              :is-expanded="expandedAssessmentHistory === index"
              @on-toggle="
                (index) => {
                  isTemplateDropdownOpen = false;
                  if (expandedAssessmentHistory === index)
                    expandedAssessmentHistory = -1;
                  else expandedAssessmentHistory = index;
                }
              "
              @select-assessment="selectAssessment"
              @selected-parent-assessment="selectedParentAssessment"
            />
          </div>
        </div>
        <div
          v-if="assessmentsHistory.length > 0"
          class="tw-flex tw-justify-start tw-items-start tw-gap-[10px] tw-self-stretch tw-px-5 tw-py-0 tw-text-[#878787] tw-text-[12px] tw-not-italic tw-font-[600] tw-leading-[100%] tw-tracking-[1.2px] tw-uppercase"
        >
          {{
            getComponentUiText(
              "app-component-assessment-create-assessment-modal-select-existing-assessment-divider-or-1",
            )
          }}
        </div>
        <div
          class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between md:tw-items-center tw-gap-[20px] md:tw-gap-[10px] tw-self-stretch tw-rounded-[4px] tw-p-[10px] md:tw-p-[25px] main"
        >
          <span
            class="tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[100%] tw-min-w-[260px]"
            >{{
              getComponentUiText(
                "app-component-assessment-create-assessment-modal-template-title-1",
              )
            }}</span
          >
          <!-- Template DROPDOWN start -->
          <div
            class="tw-flex tw-flex-col tw-w-full tw-max-w-[100%] md:tw-max-w-[630px] tw-relative"
          >
            <div
              :class="`tw-w-full tw-flex tw-flex-col tw-items-start tw-self-stretch templateAssessmentWrapper tw-bg-white tw-max-h-[400px]`"
            >
              <MutliLevelMutliSelectDropdown
                v-model="templateSelectedId"
                data-cy-id="create-assessment-template-dropdown"
                :show-description="true"
                :data="listTemplate"
                :type="DROPDOWN_TYPE.SINGLE"
                :time-updated="timeUpdated"
                :enable-search="true"
                :placeholder="
                  getComponentUiText(
                    'app-component-assessment-create-assessment-modal-template-dropdown-placeholder-1',
                  )
                "
                :dropdown-class="`!tw-static !tw-max-h-[330px] ${
                  isTemplateDropdownOpen
                    ? '!tw-border-t-[#eff0f1] !tw-border-t !tw-border-solid !tw-border-b-0 !tw-rounded-bl-[0px]'
                    : ''
                }`"
                :main-wrapper-class="'tw-rounded-[6px]'"
                :search-placeholder="
                  getComponentUiText(
                    'app-component-assessment-create-assessment-modal-template-dropdown-placeholder-search-1',
                  )
                "
                :class="'tw-w-full tw-max-w-[100%] md:tw-max-w-[630px] tw-bg-white input-default'"
                @update:is-dropdown-open="
                  (value) => (isTemplateDropdownOpen = value)
                "
                @update:model-value="
                  (value, data) => {
                    templateSelectedId = value;
                    assessmentSelected = null;
                    selectedAssessmentParent = [];
                    templateSelected = listTemplate.find(
                      (e) => e.templateId === value,
                    );
                    resetModalHistory();
                  }
                "
              >
                <template #buttonDropdown>
                  <div
                    :class="`tw-cursor-pointer tw-rounded-[6px] tw-flex tw-items-center tw-justify-between tw-gap-36 tw-self-stretch tw-p-5 tw-bg-[#FFFFFF] tw-max-w-[100%] md:tw-max-w-[630px] tw-w-full`"
                    @click="
                      () => {
                        expandedAssessmentHistory = -1;
                      }
                    "
                  >
                    <span
                      :class="`${
                        templateSelected
                          ? 'tw-text-[#211F58]'
                          : 'tw-text-[#B7B7B7]'
                      } tw-text-[15px] tw-not-italic tw-font-[400] tw-leading-[100%]`"
                      >{{
                        templateSelected
                          ? (templateSelected as any)?.templateName
                          : getComponentUiText(
                              "app-component-assessment-create-assessment-modal-template-dropdown-placeholder-1",
                            )
                      }}</span
                    >
                    <span>
                      <ArrowIconAssessment />
                    </span>
                  </div>
                </template>
              </MutliLevelMutliSelectDropdown>
            </div>
            <div
              v-if="isTemplateDropdownOpen"
              class="tw-cursor-pointer tw-flex tw-justify-between tw-items-center tw-self-stretch tw-relative tw-py-[10px] tw-bg-white tw-pr-[21px] tw-pl-[24px] tw-h-[55px] tw-border-l-2 tw-border-solid tw-border-l-[#EFF0F1] tw-border-b-[#EFF0F1] tw-border-b-[1px] tw-border-t-0 tw-border-r-0"
              @click="
                () => {
                  emit('open-manage-template-modal');
                }
              "
            >
              <p
                class="tw-mb-[0px] tw-text-[#387DFF] tw-text-[11px] tw-not-italic tw-font-[500]"
              >
                {{
                  getComponentUiText(
                    "app-assess-assessment-template-title-modal-1",
                  )
                }}
              </p>
              <ArrowIcon :class="['right-arrow']" :width="6" :height="9" />
            </div>
          </div>
          <!-- Template DROPDOWN end -->
        </div>
      </div>
      <ButtonLoading
        :title="
          getComponentUiText(
            'app-component-assessment-create-assessment-modal-create-assessment-btn-1',
          )
        "
        :disabled="!isStatusSendRequestCheckListFromMasterAll && !isLoading"
        :is-loading="isLoading"
        @click-action="checkListFromMasterAll"
      />
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { ref, watch, computed, onMounted, PropType } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import ArrowIcon from "@/components/svgs/arrowIcon.vue";
import ExistingAssessmentDropdown from "./existingAssessmentDropdown.vue";
import {
  DROPDOWN_TYPE,
  assessmentStatus,
  successStatusCodes,
} from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";
import {
  getCheckListFromMasterAll,
  createChecklistToItem,
  getCheckListDuplicate,
} from "@/services/assessment";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import { showErrorAPI } from "@/services/apiRoutes";
import { Assessment, Checklist } from "@/services/apiRoutes/routes";
import router from "@/router";
import store from "@/store";
import MutliLevelMutliSelectDropdown from "../common/mutliLevelMutliSelectDropdown/mutliLevelMutliSelectDropdown.vue";
import ArrowIconAssessment from "@/components/svgs/arrowIconAssessment.vue";
import dayjs from "dayjs";
import ButtonLoading from "../common/buttonLoading.vue";

const timeUpdated: any = ref(`${dayjs().unix()}`);
const templateSelectedId = ref("");
const listTemplate = computed(() =>
  store.state.Assessment.listTemplate.map((e) => ({
    ...e,
    title: e.templateName || "",
    selected: templateSelectedId.value === e.templateId,
    id: e.templateId,
  })),
);
const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
  assessmentsHistory: {
    type: Array as PropType<any[]>,
    required: false,
    default: () => [
      {
        name: "Risk Assessment",
        state: assessmentStatus.inProgress,
        date: "01 Sep 2023",
        isLarge: false,
        history: [
          {
            name: "Risk Assessment",
            date: "02 Sep 2023",
            state: assessmentStatus.inProgress,
            isActive: false,
            id: 1,
          },
          {
            name: "Risk Assessment",
            date: "02 Sep 2023",
            state: assessmentStatus.inProgress,
            isActive: false,
            id: 2,
          },
          {
            name: "Risk Assessment",
            date: "02 Sep 2023",
            state: assessmentStatus.inProgress,
            isActive: false,
            id: 3,
          },
          {
            name: "Risk Assessment",
            date: "02 Sep 2023",
            state: assessmentStatus.inProgress,
            isActive: false,
            id: 4,
          },
        ],
      },
      {
        name: "Risk Assessment",
        state: assessmentStatus.inProgress,
        date: "01 Oct 2023",
        isLarge: false,
        history: [
          {
            name: "Risk Assessment",
            date: "02 Sep 2023",
            state: assessmentStatus.inProgress,
            isActive: false,
            id: 1,
          },
          {
            name: "Risk Assessment",
            date: "02 Sep 2023",
            state: assessmentStatus.inProgress,
            isActive: false,
            id: 2,
          },
          {
            name: "Risk Assessment",
            date: "02 Sep 2023",
            state: assessmentStatus.inProgress,
            isActive: false,
            id: 3,
          },
          {
            name: "Risk Assessment",
            date: "02 Sep 2023",
            state: assessmentStatus.inProgress,
            isActive: false,
            id: 4,
          },
        ],
      },
    ],
  },
  templates: {
    type: Array,
    required: false,
    default: () => [
      {
        label: "Option 1",
        value: 1,
        id: 1,
      },
      {
        label: "Option 2",
        value: 2,
        id: 2,
      },
      {
        label: "Option 3",
        value: 3,
        id: 3,
      },
      {
        label: "Option 4",
        value: 4,
        id: 4,
      },
    ],
  },
});

let showRef = ref(props.show);
let notInfoVisible = ref(true);
const isTemplateDropdownOpen = ref(false);
const templateSelected: any = ref("");
const expandedAssessmentHistory = ref(-1);
const isStatusSendRequestCheckListFromMasterAll = ref(true);
const isChecked = ref(true);
const name = ref(null);
const description: any = ref("");
const autoTextarea = ref(null);
const assessmentSelected: any = ref(null);
const isLoading = ref(false);
const selectedAssessmentParent = ref<number[]>([]);

const isModalValue = ref(false);
const checklistNames = [
  "Elizabeth",
  "Emily",
  "Emma",
  "Jessica",
  "Jennifer",
  "Laura",
  "Linda",
  "Maria",
  "Rebecca",
  "Sarah",
];
watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) notInfoVisible.value = true;
    if (!value) {
      isTemplateDropdownOpen.value = false;
    }
  },
);

const autoResize = () => {
  if (autoTextarea.value) {
    autoTextarea.value.style.height = "auto"; // Reset height
    autoTextarea.value.style.height = autoTextarea.value.scrollHeight + "px"; // Set height based on content
  }
};

onMounted(() => {
  autoResize();
});

const resetModal = () => {
  assessmentSelected.value = null;
  templateSelected.value = null;
  templateSelectedId.value = "";
  props.assessmentsHistory.forEach((e: any) => {
    e.isLarge = false;
    e.history.forEach((el) => {
      el.isActive = false;
    });
  });
};
const resetModalTemplate = () => {
  templateSelected.value = null;
  templateSelectedId.value = "";
};

const emit = defineEmits([
  "update:show",
  "resetModalHistory",
  "open-manage-template-modal",
]);
const resetModalHistory = () => {
  // emit("resetModalHistory", true);
  isChecked.value = !isChecked.value;
};
const handleCloseModal = (fromModal = false) => {
  if (
    name.value ||
    description.value ||
    assessmentSelected.value ||
    templateSelected.value?.templateId
  ) {
    isModalValue.value = true;
  }
  if (fromModal && isModalValue.value) return;
  showRef.value = false;
  emit("update:show", showRef.value);
  resetModal();
  isModalValue.value = false;
};
const selectAssessment = (i) => {
  selectedAssessmentParent.value = [];
  const { data, index } = i;
  let newAssessmentSelected = null;
  if (data) {
    newAssessmentSelected =
      props.assessmentsHistory[index]?.history[data]?.checklistId;
  } else {
    newAssessmentSelected =
      props.assessmentsHistory[index]?.history[0]?.checklistId;
  }
  assessmentSelected.value =
    newAssessmentSelected === assessmentSelected.value
      ? null
      : newAssessmentSelected;
  resetModalTemplate();
  props.assessmentsHistory[index].history.forEach((el: any, index) => {
    if (index === data) {
      el.isActive = !el.isActive;
    }
  });
};

const selectedParentAssessment = (i) => {
  const { data, index } = i;
  if (selectedAssessmentParent.value.includes(index)) {
    selectedAssessmentParent.value.splice(
      selectedAssessmentParent.value.indexOf(index),
      1,
    );
    selectedAssessmentParent.value = [];
  } else {
    selectedAssessmentParent.value = [];
    selectedAssessmentParent.value.push(index);
  }
  resetModalTemplate();
  let newAssessmentSelected =
    props.assessmentsHistory[index]?.history[0]?.checklistId;
  assessmentSelected.value =
    newAssessmentSelected === assessmentSelected.value
      ? null
      : newAssessmentSelected;
  props.assessmentsHistory.forEach((e: any, index) => {
    if (index == data) {
      e.isLarge = !e.isLarge;
    }
  });
};

const getRandomItem = () => {
  const randomIndex = Math.floor(Math.random() * checklistNames.length);
  return checklistNames[randomIndex];
};

const checkListFromMasterAll = async () => {
  isLoading.value = true;
  if (assessmentSelected.value) {
    checklistIsSelectd(assessmentSelected.value);
    resetModal();
    isLoading.value = false;
    return;
  }
  if (templateSelected.value) {
    const templateId = (templateSelected.value as any).templateId;
    await createAssessment(templateId);
    resetModal();
  } else {
    await checklistIsNotSelectd();
    resetModal();
  }
  isLoading.value = false;
};

const descriptionValue = () => {
  const templateName = (templateSelected.value as any)?.templateName;

  if (!templateSelected.value) {
    return getComponentUiText(
      "app-component-assessment-create-assessment-modal-field-placeholder-description-1",
    );
  } else {
    return getComponentUiText(
      "app-component-assessment-create-assessment-modal-field-placeholder-description-when-template-data-1",
      false,
      {
        templateName,
      },
    );
  }
};

const descriptionNameValue = () => {
  if (!templateSelected.value) {
    return getComponentUiText(
      "app-component-assessment-create-assessment-modal-field-placeholder-name-1",
    );
  } else {
    return getComponentUiText(
      "app-component-assessment-create-assessment-modal-field-placeholder-name-1-when-template-data-1",
      false,
      {
        totalAssessment: totalAssessment.value
          ? `${totalAssessment.value + 1}`
          : "1",
      },
    );
  }
};
const totalAssessment = computed(() => {
  let count = 0;
  props.assessmentsHistory.forEach((e: any) => {
    count += e.history.length;
  });
  return count;
});

const checklistIsSelectd = async (templateId) => {
  const res = await getCheckListDuplicate(templateId);
  if (
    res.data?.data &&
    res.status === successStatusCodes.OK &&
    typeof res.data.data === "object" &&
    "checklistId" in res.data.data
  ) {
    const checklistId = res.data.data.checklistId as number;
    const query = { checklistId: checklistId };
    router.push({ path: "/assess/input", query });
  } else {
    showError(res.data.message);
  }
};
const createAssessment = async (templateId) => {
  try {
    const data = {
      templateId: templateId,
      checklistName: name.value
        ? name.value
        : `Assessment ${totalAssessment.value ? totalAssessment.value + 1 : 1}`,
      checklistDescription: description.value
        ? description.value
        : descriptionValue(),
      checklistNotes: "",
    };
    const res = await createChecklistToItem(data);
    if (
      res.data?.data &&
      res.status === successStatusCodes.OK &&
      typeof res.data.data === "object" &&
      "checklistId" in res.data.data
    ) {
      const checklistId = res.data.data.checklistId as number;
      const query = { checklistId: checklistId };
      router.push({ path: "/assess/input", query });
    }
  } catch (error) {
    showErrorAPI(error, Checklist.createChecklistToItem);
  }
};
const checklistIsNotSelectd = async () => {
  try {
    if (isStatusSendRequestCheckListFromMasterAll.value) {
      const checkName = {
        checklistName: getRandomItem(),
      };
      isStatusSendRequestCheckListFromMasterAll.value = false;
      const params = {
        checklistName: name.value
          ? name.value
          : `Assessment ${
              totalAssessment.value ? totalAssessment.value + 1 : 1
            }`,
        checklistDescription: description.value
          ? description.value
          : "Assessment created from all available questions",
        checklistNotes: "",
      };
      const res = await getCheckListFromMasterAll(params);
      isStatusSendRequestCheckListFromMasterAll.value = true;
      if (
        res.data?.data &&
        res.status === successStatusCodes.OK &&
        typeof res.data.data === "object" &&
        "checklistId" in res.data.data
      ) {
        const checklistId = res.data.data.checklistId as number;
        const query = { checklistId: checklistId };
        router.push({ path: "/assess/input", query });
      } else {
        showError(res.data.message);
      }
    }
  } catch (error: any) {
    showErrorAPI(error, Assessment.checkListFromMasterAll);
  } finally {
    isStatusSendRequestCheckListFromMasterAll.value = true;
  }
};
const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};
</script>

<style lang="scss" scoped>
.main {
  border: 1px solid #eff0f1;
  background: rgba(239, 240, 241, 0.5);
  transition: all 0.3s ease-in-out;
}

.templateAssessmentWrapper {
  background: #fcfcfd;
  transition: all 0.3s ease-in-out;
  border: 1px solid #eff0f1;
  border-radius: 6px;
  background: #ffffff;
  max-height: 400px;
}

.templateAssessmentWrapper .templateDropdownItem {
  transition: all 0.3s ease-in-out;
  color: #231f20;
  font-size: 13px;
  font-weight: 400;
}

.templateAssessmentWrapper .templateDropdownItem:hover {
  background: #f2f8ff;
}

.templateAssessmentWrapper .templateDropdownItem:not(:last-child) {
  border-bottom: 1px solid #eff0f1;
}

.close {
  height: 0;
  padding: 0;
  overflow: hidden;
  filter: blur(1px);
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

textarea::placeholder {
  color: #b7b7b7;
  font-size: 15px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

input::placeholder {
  color: #b7b7b7;
  font-size: 15px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.auto-expand {
  width: 100%;
  overflow-y: hidden;
  resize: none;
  outline-color: #eff0f1;
  line-height: 18px;
  color: #231f20;
}
</style>
